import script from "./TagValuePercent.vue?vue&type=script&setup=true&lang=js"
export * from "./TagValuePercent.vue?vue&type=script&setup=true&lang=js"

import "./TagValuePercent.vue?vue&type=style&index=0&id=53eb8eb1&lang=scss"

const __exports__ = script;

export default __exports__